module.exports = __webpack_public_path__ + "img/pay_wechat.5dc60bfb.png";